<template> 
   
     <router-view></router-view>
   
</template> 
<script>
   
    export default {
        name:'user',
        data () {
            return {
             
            }
        },
       

        computed: {
          
            
        },
        methods: {
               
           
            
        },
      
        mounted: function(){
            var that = this;
          
        }
    }
</script>  
<style scoped>
    
</style>
     